<template>
  <modal
    class="comment"
    :name="'comment-modal' + postId"
    width="90%"
    height="auto"
  >
    <Button
      class="close"
      @click.native="$modal.hide('comment-modal' + postId)"
      margin="10px"
      color="#31b9be"
      bgcolor="transparent"
      width="30px"
      padding="0"
      icon="close-blue"
    ></Button>
    <h3>{{ title }}</h3>
    <TextAreaField
      rows="3"
      v-model="comment"
      labelTitle
      :placeholder="$t('general.feed.comment.placeholder')"
    ></TextAreaField>
    <Button
      :title="$t('general.feed.comment.placeholder')"
      shadow="true"
      @click.native="postComment"
      margin="1rem 0"
    ></Button>
  </modal>
</template>
<script>
export default {
  name: "CommentModal",
  props: {
    title: { required: true },
    postId: { required: true }
  },
  data: function() {
    return {
      comment: ""
    };
  },
  methods: {
    postComment() {
      this.$emit("post-comment", {
        postId: this.postId,
        comment: this.comment
      });
      this.$modal.hide("comment-modal" + this.postId);
      this.comment = "";
    }
  }
};
</script>
